module.exports = __webpack_public_path__ + "static/media/arrow-rightdd19c320.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/arrow-right.svg
// module id = 116
// module chunks = 0